export default __webpack_public_path__ + "static/media/reactjs.47f97ea2.svg";